/* Mach Outlet — pestañas de la ficha de producto (Descripción / Detalles / Envío).
   Sin JavaScript todas las secciones se ven una debajo de otra. */
(function () {
  function init() {
    document.querySelectorAll('[data-mo-tabs]').forEach(function (root) {
      if (root.dataset.moReady === '1') return;
      root.dataset.moReady = '1';
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      var panels = tabs.map(function (t) {
        return document.getElementById(t.getAttribute('aria-controls'));
      });
      if (!tabs.length) return;
      root.classList.add('is-enhanced');

      function select(index, focus) {
        tabs.forEach(function (t, i) {
          var on = i === index;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          if (panels[i]) panels[i].hidden = !on;
        });
        if (focus) tabs[index].focus();
      }

      var start = tabs.findIndex(function (t) {
        return t.getAttribute('aria-selected') === 'true';
      });
      select(start < 0 ? 0 : start, false);

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          select(i, false);
        });
        tab.addEventListener('keydown', function (e) {
          var n = tabs.length;
          if (e.key === 'ArrowRight') { e.preventDefault(); select((i + 1) % n, true); }
          else if (e.key === 'ArrowLeft') { e.preventDefault(); select((i - 1 + n) % n, true); }
          else if (e.key === 'Home') { e.preventDefault(); select(0, true); }
          else if (e.key === 'End') { e.preventDefault(); select(n - 1, true); }
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
